module.exports = __webpack_public_path__ + "static/panel_illustration-577316e63b13829780732863027553e6.png";